import Vue from 'vue'
//directive：注册一个全局的指令 v-preventReClick 
const preventReClick = Vue.directive('preventReClick', {
    //inserted：当被绑定的元素插入进DOM时发生的调用
    inserted: function (el, binding) {
        //el:指令绑定的元素。用来操作DOM  binding：一个对象
        el.addEventListener('click', () => {
            console.log('走重复点击')
            //addEventListener() 方法用于向指定元素添加事件
            if (!el.disabled) {
                //判断当前元素如果不是禁用的状态 
                el.disabled = true //开启按钮禁用
                setTimeout(() => { //加定时器 3秒后把定时器关闭
                    el.disabled = false
                    console.log('关闭定时器')
                }, binding.value || 3000)
                //binding.value可以自行设置。如果设置了则跟着设置的时间走
                //例：v-preventReClick='2000'
            }
        })
    }
});

export default preventReClick


// WEBPACK FOOTER //
// ./src/utils/preventReClick.js